import ProductLegacyCard from './ProductLegacyCard';

export default ProductLegacyCard;
